
import { Component } from '@angular/core';
import { GLOBAL_TOAST_KEY } from '@app/core/constants';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'ifa-global-toast',
    templateUrl: './global-toast.component.html',
    imports: [ToastModule]
})
export class GlobalToastComponent {
  key = GLOBAL_TOAST_KEY;
}
